import moment from 'moment-timezone';
import PopupWrapper from '../popupWrapper/popupWrapper.vue';
import Vue from 'vue';

import template from 'raw-loader!./savedSearchPopup.html';

const DIAL_BACK_TO_FAVORITE_LIMITS = {
  4: 1,
  24: 5,
  168: 10,
  720: 1000,
};
const DIAL_BACK_TO_HISTORY_LIMITS = {
  4: 10,
  24: 10,
  168: 1000,
  720: 1000,
};

let savedSearchPopup = Vue.component('savedSearchPopup', {
  name: 'SavedSearchPopup',
  template: template,
  props: {
    activeTab: {
      type: String,
      default: false
    },
    isAdding: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      default: () => []
    },
    favorites: {
      type: Array,
      default: () => []
    },
    dialBackHours: {
      type: Number,
      default: 720
    },
  },
  data: function() {
    let copy = [...this.favorites];
    return {
      tab: this.activeTab,
      errorMessage: '',
      hasError: false,
      newFavoriteName: 'Untitiled',
    };
  },
  computed: {
    historyMap: function() {
      return makeHistoryMap(this.history);
    },
    currentFavorites: function() {
      let copy = [...this.favorites];
      return copy.reverse();
    }
  },
  watch: {
    isAdding: function(isAdding) {
      if (isAdding) {
        window.setTimeout(() => {
          let input = document.getElementById('addingInput');
          if (input) {
            input.focus();
            input.select();
          }
        }, 100);
      }
    },
    activeTab: function(activeTab) {
      this.tab = activeTab;
    },
  },
  methods: {
    calculateTime: (timestamp) => {
      return moment(timestamp).format('hh:mm:ss');
    },
    deleteFavorite: function(favorite) {
      this.$emit('delete-favorite', favorite);
    },
    deleteHistory: function(history) {
      this.$emit('delete-history', history);
    },
    enableFavorite: function(favorite) {
      this.$emit('enable-favorite', favorite);
    },
    enableHistory: function(history) {
      this.$emit('enable-history', history);
    },
    handleAdd: function() {
      let name = this.newFavoriteName;
      this.newFavoriteName = 'Untitled';
      this.$emit('favorite-added', name);
    },
    handleClose: function() {
      this.newFavoriteName = 'Untitled';
      this.$emit('popup-close');
    },
    handleRename: function(favorite) {
      favorite.isEditing = false;
      this.$emit('favorite-renamed', favorite);
      this.$forceUpdate();
    },
    getFavoritesLimit: function() {
      return DIAL_BACK_TO_FAVORITE_LIMITS[this.dialBackHours] || 1;
    },
    getHistoryLimit: function() {
      return DIAL_BACK_TO_HISTORY_LIMITS[this.dialBackHours] || 10;
    },
    renameFavorite: function(favorite, i) {
      favorite.isEditing = true;
      let self = this;
      window.setTimeout(() => {
        let input = self.$refs['editingInput'+i][0];
        if (input) {
          input.focus();
          input.select();
        }
      }, 100);

      this.$forceUpdate();
    },
    switchTabs: function() {
      if (this.tab === 'history') {
        this.tab = 'favorites';
      } else {
        this.tab = 'history';
      }
    },
  },
  components: {
    'popup-wrapper': PopupWrapper,
  },
});

function makeHistoryMap(historyArray) {
  let historyMap = {};
  if (!historyArray || !historyArray.reverse) {
    return;
  }
  let copy = [...historyArray];
  copy.reverse();
  copy.forEach((state) => {
    let day = moment(state.created).format('DD MMM YYYY');
    if (historyMap[day]) {
      historyMap[day].push(state);
    } else {
      historyMap[day] = [state];
    }
  });
  return historyMap;
}

export default savedSearchPopup;
